var QueryString = (function () {
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        // If first entry with this name
        if (typeof query_string[pair[0]] === 'undefined') {
            query_string[pair[0]] = pair[1];
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === 'string') {
            var arr = [query_string[pair[0]], pair[1]];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(pair[1]);
        }
    }
    return query_string;
})();

(function ($) {
    // IO measuring
    // True if io settings are present.
    var ioMeasuring = false;
    if (typeof ioSettings === 'object') {
        ioMeasuring = true;

        /**
         * @name sendIoPageEvent
         * @description Send pageview event to IO tracking system.
         */
        var sendIoPageEvent = function () {
            var ioPageViewConfig = {
                event: 'pageviews',
                config_page_url: ioSettings.page_url,
                type_article: 'Listed',
            };

            try {
                window.io(ioPageViewConfig);
            } catch (e) {
                console.error(e);
            }
        };
    }

    $.fn.listArticle = function (settings) {
        var listIt = 0;
        var notMakeActive = 0;
        var options = {
                paging: 0,
                pagingBy: 5,
                fadeIn: 500,
                fadeOut: 100,
                magazine: 'blesk',
                forcepaging: 0,
                showRecentArticles: true,
            },
            settings = settings,
            $that = $(this),
            chapterIds = [];
        options = $.extend(options, settings);

        if (options.paging == 1) {
            var paging = {
                //aktivní skupina paging odkazů
                firstVisibleAnchorIndexOfChapters: null,
                lastVisibleAnchorIndexOfChapters: null,
                inProgress: 0,
                style: null,
            };
            $('ul.main li').siblings('strong').remove();
        }

        if (typeof $.cookie('newuser') != 'undefined') {
            if (options.magazine == 'blesk') {
                $.cookie('newuser', 1);
                listIt = 1;
            } else {
                /*PŮVODNÍ PODMÍNKA LISTOVÁNÍ
            *
            if (($.cookie('newuser') == 1) || options.forcepaging == 1){
                 if (options.magazine == "blesk") {

                    listIt = 0;
                 }
                 else if (options.magazine == "bpz") {
                    listIt = 0;

                 }
            } */
                listIt = 1;
            }
        } else {
            if (options.magazine == 'blesk') {
                $.cookie('newuser', 1);
            }
            listIt = 1;
        }

        if (listIt == 1) {
            if (options.magazine != 'bpz') {
                $that.find('.inner_7').removeClass('inner_7').addClass('inner_8');
                //sirka clanku
                var gridWidth,
                    //padding jednotlivých li
                    padding;
                // if(options.magazine == "isport") gridWidth = $that.find("[class^='grid_8']").width();
                // else if(options.magazine == "blesk") gridWidth = $that.find("#article").width();
                // else gridWidth = $that.find("[class^='inner_']").width()
                gridWidth = $that.find('#article').width() - 20;
                switch (options.paging) {
                    case 0:
                        padding = 0;
                        break;
                    default:
                        padding = 10;
                }
            }

            //načtení hashe
            hash = getHash();
            //načtení parametru kapitola z URL
            section = getSection();

            if (options.magazine === 'bpz') $that.removeClass('notlisted').addClass('listed');
            $that.find('.notlisted').removeClass('notlisted').addClass('listed');
            $that
                .find('ul.main')
                .addClass('listed')
                .css('display', 'block')
                .children('li')
                .each(function (i) {
                    if (options.paging == 0) {
                        if (i == 0) {
                            if (options.magazine == 'blesk') {
                                $(this).find('h1, .leadsection').css('margin-left', '80px');
                            }
                        }
                        if (i >= 1) {
                            chapterIds.push($(this).data('id'));
                        }
                    } else {
                        if (i == 0) {
                            $(this).attr('data-id', 'intro');
                            chapterIds.push($(this).data('id'));
                        }
                        if (i >= 1) {
                            chapterIds.push($(this).data('id'));
                        }
                    }

                    if (!section) {
                        if (i === 0) {
                            $(this).addClass('active');
                        }
                    } else {
                        $('li[data-id=' + section.replace('#', '') + ']').addClass('active');
                    }
                    if (options.magazine == 'blesk') {
                        $(this).removeClass('pseudoInner_7');
                        if ($(this).attr('id') !== 'related') {
                            $(this)
                                .css('width', '610px')
                                .css('margin', '0 auto')
                                .css('float', 'none');
                        }
                    } else {
                        $(this).css('padding', 0).css('padding-bottom', '10px');
                    }
                });
            console.log(chapterIds);
            if (settings.paging === 0) {
                controlsButtons = $that.find('.listingControlButtons');
                smallControlButtons = controlsButtons.clone();
                smallControlButtons
                    .addClass('smallControlButtons')
                    .css('display', 'block')
                    .find('.counter')
                    .remove();
                if (options.magazine == 'bpz') {
                    $that.find('ul.listed > li').each(function () {
                        $(this)
                            .find('.artSectionTop')
                            .prepend(
                                smallControlButtons
                                    .removeClass('artSectionBottom')
                                    .addClass('sectionPaging')
                                    .clone(),
                            );
                    });
                } else if (options.magazine == 'blesk') {
                    //PUVODNI_BLESK_VERZE-$that.find(".bottom .clearfix").before(smallControlButtons);
                } else {
                    $that.find('ul.listed').append(smallControlButtons);
                }
            } else {
                $that.find('ul.listed').before("<div class='paging' style='min-width:100%'/>");
                $that.find('ul.listed').after("<div class='paging' style='min-width:100%'/>");

                $that
                    .find('.paging')
                    .append(
                        "<button class='prev showPrev'><div class='pagingPrevArrow'></div>Předchozí</button>" +
                            "<div class='pagingHolder'></div>" +
                            "<button class='next showNext'>Další<div class='pagingNextArrow'></div></button>",
                    );
                $that.find('.paging').after("<div class='clearfix' />");
                $that.find('.paging').append("<div class='clearfix' />");
                var pagingPosition = $that.find('.paging .pagingHolder');

                for (var i = 0; i <= chapterIds.length - 1; i++) {
                    if (i == 0) {
                        name = 'úvod';
                        id = chapterIds[i];
                    } else if (i == chapterIds.length - 1) {
                        if (
                            $that.find('ul.listed > li:nth-child(' + (i + 1) + ')').data('id') ==
                            'related'
                        ) {
                            name = 'více';
                        } else {
                            name = i;
                        }
                        id = chapterIds[i];
                    } else {
                        name = i;
                        id = chapterIds[i];
                    }

                    if (String(id).includes('disabled')) {
                        pagingPosition.append("<a class='disabled'>" + name + '</a>');
                    } else {
                        pagingPosition.append(
                            "<a href='#' data-id=" +
                                id +
                                ' data-parts=' +
                                chapterIds.length +
                                '>' +
                                name +
                                '</a>',
                        );
                    }
                }

                if (settings.paging === 1) controlPagingElements();

                //zamknutí buttonů v případě placeného článku-zjištování přes loginový box
                /*if($(".login-box").length){
                           $("button.prev").replaceWith("<div class='prev'><div class='pagingPrevArrow'></div>Předchozí</div>");
                           $("button.next").replaceWith("<div class='next'>Další<div class='pagingNextArrow'></div></div>");
                           $(".pagingHolder").replaceWith("<div class='pagingHolder'><span data-id='intro' class='active'>Úvod</span><span data-id='related'>Více</span></div>");
                           $("<div class='block-bg-buttons'></div>").appendTo(".paging");
                }*/
            }

            var authors = $that.find('.authors');
            $(document).ready(function () {
                console.log('\n\n', options, '\n\n');

                var socialShares = $that.find('.socialShares').clone();
                $that.find('.socialShares').hide();

                if (options.magazine == 'blesk') {
                    /*PUVODNI_BLESK_VERZE-$that.find("ul.listed li:first-child .articleDetails").append(socialShares);
                    $that.find("ul.listed li:first-child .articleDetails .socialShares").css("margin-left", "80px");
                    socialShares.css("margin-left", 0);
                    $that.find(".bottom .clearfix").before(socialShares);
                    if ($that.find("ul.listed li:first-child[class='active']").length == 1) {
                        $that.find(".bottom .socialShares").hide();
                        $that.find(".articleDetails .socialShares").show();
                    }*/
                    $that.find('.articleDetails .socialShares').show();
                }
                if (options.magazine == 'isport' || options.magazine == 'blesk') {
                    $that.find('ul.main >li').each(function () {
                        $(this).append("<div class='social' />");
                    });
                    if (options.magazine == 'isport') {
                        var authors = $that
                            .find('.authors')
                            .css('float', 'margin-right')
                            .removeClass('underArticle')
                            .removeClass('mt0px')
                            .clone();
                        $that.find('.authors').hide();
                        $that
                            .find('.social')
                            .append(socialShares.css('float', 'left'))
                            .append(authors.removeClass('authors').css('text-align', 'center'));
                    } else {
                        //$that.find(".social").append(authors.removeClass("authors").css("text-align", "left"));
                        $that
                            .find('.imgInArt')
                            .append(socialShares.css('float', 'left').css('clear', 'both'));
                        $that.find('.articleDetails .socialShares').show();
                    }
                    $that.find('.socialMedia').hide();
                    $that.find('.bottom .socialShares > *').hide();
                }
            });
            if (options.magazine == 'blesk') {
                /*PUVODNI_BLESK_VERZE-var related = $that.find("ul.listed li#related").length;
                $that.find(".socialMedia").hide();
                $that.find(".bottom .authors:not(.autorLeft)").css("margin-left", "80px");
                $that.find(".leadsection p").css("font-weight", "normal");
                if(related === 1) $that.find(".listingControlButtons .totalNumber").html(chapterIds.length-1);
                else $that.find(".listingControlButtons .totalNumber").html(chapterIds.length);
                $that.find(".listingControlButtons").css("display", "block");*/
                // $that.find("ul.main").addClass("inner_8");
            }
            if (options.magazine == 'bpz') {
                $that.find('.listingControlButtons').show();
                $that.find('.listingControlButtons .counter').addClass('numbers');
                $that.find('.listingControlButtons .totalNumber').html(chapterIds.length);
                $('#content .articleContent .articlePerex p').css('font-weight', 'normal');
                $('ul.listed > li').css('font-size', '17px').css('line-height', '22px');
            }

            buttonsControl($that.find('ul.listed > li.active'));
            $that.find('.listingControlButtons button, .paging button').click(function () {
                buttonPressed($(this));
            });
            $that.find('.paging a[data-id]').click(function (e) {
                e.preventDefault();
                paging.oldItem = $that.find('ul.listed > li.active');
                paging.newItem = $that.find('ul.listed li[data-id="' + $(this).data('id') + '"]');
                $that.find('.paging a.active').each(function () {
                    $(this).removeClass('active');
                });

                hideAndShowNext(paging.oldItem, paging.newItem);
            });
        }
        //getter for hash
        function getHash() {
            return window.location.hash;
        }
        function getSection() {
            return QueryString.kapitola;
        }
        //keypress navigation
        $('body').keydown(function (e) {
            e.stopImmediatePropagation();
            if (e.keyCode == 37) {
                // left
                var activeId = $that.find('ul.listed > li.active').data('id');
                if (options.paging == 0) {
                    if (chapterIds.indexOf(activeId) >= 0)
                        buttonPressed($that.find('.listingControlButtons button.prev'));
                } else {
                    if (chapterIds.indexOf(activeId) > 0)
                        buttonPressed($that.find('.listingControlButtons button.prev'));
                }
            } else if (e.keyCode == 39) {
                // right
                var activeId = $that.find('ul.listed > li.active').data('id');
                if (chapterIds.indexOf(activeId) + 1 < chapterIds.length)
                    buttonPressed($that.find('.listingControlButtons button.next'));
            }
        });
        function buttonPressed(button) {
            var cls = button.attr('class'),
                oldItem = $that.find('ul > li.active'),
                dir,
                newItem;

            if (cls.search('showStart') != -1) dir = 'showStart';
            else if (cls.search('showNext') != -1) dir = 'next';
            else if (cls.search('showPrev') != -1) dir = 'prev';
            else dir = 'error';
            switch (dir) {
                case 'next':
                    newItem = oldItem.next('li');
                    break;
                case 'prev':
                    newItem = oldItem.prev('li');
                    break;
                case 'showStart':
                    newItem = $that.find('ul > li:first-child');

                    break;
                case 'error':
                    newItem = 'error';
                    break;
            }
            hideAndShowNext(oldItem, newItem);
        }
        buttonsControl($that.find('#article ul.main > li.active'));
        function hideAndShowNext(oldItem, newItem) {
            var oldItem = oldItem,
                newItem = newItem,
                goToNext = 1;

            if (options.paging === 1) paging.inProgress = 1;
            if (options.magazine == 'blesk') {
                scrollToArticleTop();
            }
            if (newItem != 'error') {
                $that.find('ul.listed li.active').removeClass('active');
                oldItem.fadeOut(options.fadeOut, function () {
                    oldItem.removeClass('active');
                    buttonsControl(newItem);
                    newItem
                        .addClass('active')
                        .hide()
                        .fadeIn(options.fadeIn, function () {
                            if (options.paging === 1) {
                                paging.inProgress = 0;
                                applyPagingStyle(
                                    calculateActivePagingStyle(
                                        chapterIds.indexOf(newItem.data('id')),
                                    ),
                                );
                            }

                            hashControl(newItem.data('id'));
                        });
                });
                if (options.paging === 1) {
                    $('.paging a.active').removeClass('active');
                    hashControl(newItem.data('id'));

                    paging.pagingDiv
                        .find('a[data-id="' + newItem.data('id') + '"]')
                        .addClass('active');
                    notMakeActive = 1;
                    controlPagingElements();
                }

                // pokud mame sendIoPageEvent zavolame
                if (typeof sendIoPageEvent === 'function') {
                    // Zavolani IO eventu pro virtualni PV soucasne stranky
                    sendIoPageEvent();
                }
            }

            // if(newItem != "error"){
            //     hashControl(newItem.data("id"));

            // }

            // nastavit hodnoty GA pro listovani
            var pagePath = location.pathname + window.location.search;
            var pageTitle = document.title;
            dataLayer.push({ event: 'ga.pageview', pagePath: pagePath, pageTitle: pageTitle });
            dataLayer.push({ event: 'ga.pageview', pagePath: pagePath, pageTitle: pageTitle });

            // obnovit reklamu
            if (typeof window.__cncAdsReload !== 'undefined') {
                window.__cncAdsQueue = window.__cncAdsQueue || [];
                window.__cncAdsQueue.push(function () {
                    window.__cncAdsReload();
                });
            }

            // Marfeel | PV
            window.marfeel = window.marfeel || { cmd: [] };
            window.marfeel.cmd.push([
                'compass',
                function (compass) {
                    compass.trackNewPage();
                },
            ]);
        }

        function buttonsControl(newItem) {
            var buttons = $that.find('.listingControlButtons'),
                newItem = newItem,
                itemId = newItem.data('id'),
                currentIndex = chapterIds.indexOf(itemId);
            var isNotLastChapterNotOnBlesk =
                    currentIndex != -1 &&
                    currentIndex + 1 < chapterIds.length &&
                    options.magazine !== 'blesk',
                isNotLastChapterOnBlesk =
                    currentIndex != -1 &&
                    currentIndex < chapterIds.length - 2 &&
                    options.magazine == 'blesk',
                withoutRelatedArticles =
                    currentIndex == chapterIds.length - 2 && options.showRecentArticles == false;

            $('button.next.disabled').removeAttr('disabled').removeClass('disabled');

            if (!itemId || itemId == 'intro') {
                buttons.find('button.prev, button.next, .counter, .showStart').hide();
                buttons.find('button.moreArticles').hide();
                $that.find('.authors').show();

                if (settings.paging == 1) {
                    var nextBtn = $that.find('.paging .next');
                    if (!nextBtn.hasClass('showNext')) nextBtn.addClass('showNext');
                    $that.find('.paging .showPrev').removeClass('showPrev');
                }
                //harakiri-hack: hiding social buttons
                if (options.magazine == 'blesk') {
                    /*PUVODNI_BLESK_VERZE-$that.find(".authors").show();
                  buttons.find("button.startListing").show();
                  $that.find(".smallControlButtons").show();
                  $that.find(".bottom .socialShares").hide();
                  $that.find(".articleDetails .socialShares").show();*/
                }

                //odlisne chovani BPZ
                if (options.magazine == 'bpz') {
                    buttons.find('button.startListing').hide();
                    buttons.find('button.next').show();
                    buttons.find('span.next').hide();
                    $('.bottom').css('margin-left', '-139px');
                    $('.articleContent > h1')
                        .unbind('click', showIntro)
                        .unbind('mouseover')
                        .click(function (e) {
                            e.preventDefault();
                        });
                }
            } /*PUVODNI_BLESK_VERZE-else if ((currentIndex == chapterIds.length -2) && options.magazine == "blesk" && options.showRecentArticles == true) { //předposlední pouze blesk
                var related = $that.find("ul.listed li#related").length;

                buttons.find("buttton, .counter").hide();
                if(related === 1) {
                    buttons.find("button.moreArticles, button.prev, button.next:not(.moreArticles)").show();
                    buttons.find("button.next:not(.moreArticles)").hide();
                }
                else {
                    buttons.find("button.prev, button.next:not(.moreArticles), .counter").show();
                }
            }*/ else if (
                currentIndex + 1 == chapterIds.length ||
                withoutRelatedArticles ||
                String(chapterIds[currentIndex + 1]).includes('disabled')
            ) {
                $('button.next').attr('disabled', 'disabled').addClass('disabled');
                //buttons.find(".counter").hide();
                buttons.find('button.next, button.startListing').hide();
                buttons.find('button.showStart').show();
                buttons.find('button.prev').removeClass('showStart');
                buttons.find('.moreArticles').hide();

                if (settings.paging == 1) {
                    var prevBtn = $that.find('.paging .prev');
                    if (!prevBtn.hasClass('showPrev')) prevBtn.addClass('showPrev');
                    $that.find('.paging .showNext').removeClass('showNext');
                }

                //odlisne chovani blesk
                if (options.magazine == 'blesk') {
                    /*PUVODNI_BLESK_VERZEbuttons.find("button.prev").hide();
					 $that.find(".smallControlButtons").hide();
					 $that.find(".authors").hide();
					 buttons.find("buttton, .counter").hide();
					 $that.find(".socialShares").hide();*/
                }

                //odlisne chovani BPZ
                if (options.magazine == 'bpz') {
                    buttons.find('button.next').before('<span class="next" />');
                    buttons.find('button.showStart').hide();
                    $('.bottom').removeAttr('style');
                }
            } /*PUVODNI_BLESK_VERZE-else if (currentIndex == 0 && options.magazine == "blesk") {
                $that.find(".listingControlButtons .moreArticles, .listingControlButtons .startListing, .listingControlButtons .showStart").hide();
                $that.find('.listingControlButtons .prev, .listingControlButtons .next:not(".moreArticles"), .listingControlButtons .counter').show();
                if (options.magazine == "blesk") {
                    $that.find(".bottom .socialShares").css("margin-left", 0).show();
                    $that.find(".bottom .authors").hide();

                }
            } else if (currentIndex == 1 && options.magazine == "blesk") {
                $that.find(".listingControlButtons .moreArticles, .listingControlButtons .startListing, .listingControlButtons .showStart").hide();

                $that.find('.listingControlButtons .prev, .listingControlButtons .next:not(".moreArticles")').show();


            }*/ else if (isNotLastChapterNotOnBlesk || isNotLastChapterOnBlesk) {
                buttons.find('.showStart, .startListing').hide();
                buttons.find('button.prev, button.next, .counter').show();
                buttons.find('.moreArticles').hide();

                if (options.magazine == 'blesk') {
                    $that.find('.bottom .socialShares').css('margin-left', 0).show();
                    //$that.find(".bottom .authors").hide();
                }

                if (currentIndex === 0) {
                    buttons.find('.showPrev').addClass('showStart');
                    buttons.find('.moreArticles').hide();
                } else if (currentIndex > 0) {
                    buttons.find('.showPrev').removeClass('showStart');
                }

                if (options.paging == 1) {
                    var next = $that.find('.paging button.next'),
                        prev = $that.find('.paging button.prev');

                    if (next.hasClass('showNext') == false) next.addClass('showNext');
                    if (prev.hasClass('showPrev') == false) prev.addClass('showPrev');
                }

                //harakiri-hack: showing social buttons, hiding authors
                if (options.magazine == 'blesk') {
                    $that.find('.bottom .socialShares').css('margin-left', 0).show();
                    //$that.find(".bottom .authors").hide();
                }

                //odlisne chovani BPZ
                if (options.magazine == 'bpz') {
                    buttons.find('span.prev, span.next').hide();
                    buttons.find('button.startListing').hide();

                    buttons.find('button.next, .counter').show();
                    $('.bottom').removeAttr('style');
                    $('.articleContent > h1').mouseover(function (e) {
                        e.stopImmediatePropagation();
                        $(this)
                            .css({
                                color: '#FF0036',
                                'text-decoration': 'underline',
                                cursor: 'pointer',
                            })
                            .mouseleave(function () {
                                $(this).removeAttr('style');
                            })
                            .bind('click', showIntro);
                    });
                }
            } else {
                console.log('nothing');
            }

            if (options.magazine == 'bpz' && currentIndex == 0) {
                $that.find('.smallControlButtons .showPrev').removeClass('showStart').show();
            }

            counterControl(currentIndex + 1);
        }

        function counterControl(position) {
            var position = position;
            if (
                position > 0 &&
                chapterIds.indexOf(position) <= chapterIds.length &&
                options.paging == 0
            ) {
                $that.find('.counter .actualNumber').html(position);
            }
        }

        function hashControl(id) {
            var id = id;
            if (typeof id === 'undefined') {
                history.pushState('', document.title, window.location.pathname);
            }
            if (id && id != 'intro') {
                window.history.pushState(null, null, '?kapitola=' + id);
            } else {
                history.pushState(
                    '',
                    document.title,
                    window.location.pathname + window.location.search,
                );
            }
        }

        // function hashControl(id) {
        //     var id = id;
        //     if (id && id != "intro") {
        //         window.history.pushState(null, null, "#" + id);
        //     }
        //     else {
        //         history.pushState("", document.title, window.location.pathname + window.location.search);
        //     }
        // }

        function controlPagingElements() {
            var section = getSection();
            if (section && paging.inProgress === 0 && notMakeActive != 1) {
                $that
                    .find('.paging a[data-id="' + section.replace('#', '') + '"]')
                    .addClass('active');
            }

            var activeAnchor = $that.find('.paging a.active');
            if (options.paging === 1) paging.pagingDiv = $that.find('.paging');

            //if no active paging anchor, make the "intro" one active!
            if (paging.inProgress === 0) {
                if (!activeAnchor.length) {
                    activeAnchor = $that.find('.paging a[data-id="intro"]').addClass('active');
                }
            }
            controlPagingButtons(activeAnchor);
            if (options.paging === 1) paging.inProgress = 0;
        }

        function controlPagingButtons(activeAnchor) {
            var pagingDiv = paging.pagingDiv,
                pagingBy = options.pagingBy,
                showPagingSystem,
                activeAnchor = activeAnchor.data('id'),
                activeAnchorIndexOfChapters = chapterIds.indexOf(activeAnchor);
            //set showPagingSystem - threeDots
            if (chapterIds.length <= pagingBy || chapterIds.length <= 12) {
                paging.showPagingSystem = false;
            } else {
                paging.showPagingSystem = true;
            }
            //hashControl(activeAnchor);
            if (paging.showPagingSystem == true) {
                threeDots = $('<a href="#" class="threeDots" style="cursor: default;">...</a>');
                $that.find('.pagingHolder').addClass('centered');
                //put threeDots in place
                if (paging.pagingDiv.find('a.next').length <= 0) {
                    paging.pagingDiv.find('.pagingHolder a:first-child').before(
                        threeDots
                            .clone()
                            .addClass('prev')
                            .attr('data-moveto', 'prev')
                            .bind('click', function (e) {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                // switchPaging($(this))
                            }),
                    );
                    paging.pagingDiv.find('.pagingHolder a:last-of-type').after(
                        threeDots
                            .clone()
                            .addClass('next')
                            .attr('data-moveto', 'next')
                            .bind('click', function (e) {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                // switchPaging($(this))
                            }),
                    );
                }

                paging.pagingDiv.find('a.next').hide();
                paging.pagingDiv.find('a.prev').hide();
                applyPagingStyle(calculateActivePagingStyle(activeAnchorIndexOfChapters));
            }
        }

        function calculateActivePagingStyle(activeAnchorIndexOfChapters) {
            //output as "fromStart"/"almostStart"/"between"/"almostEnd"/"toEnd"
            console.log(activeAnchorIndexOfChapters);

            var style,
                pagingBy = options.pagingBy,
                activeIndex = activeAnchorIndexOfChapters;
            if (activeIndex == pagingBy - 1) {
                style = 'almostStart';
            } else if (activeIndex <= pagingBy - 2) {
                style = 'fromStart';
            } else if (chapterIds.length - pagingBy == activeIndex) {
                style = 'almostEnd';
            } else if (chapterIds.length - pagingBy <= activeIndex) {
                style = 'toEnd';
            } else {
                style = 'between';
            }
            return style;
        }

        function applyPagingStyle(style) {
            var style = style;
            if (settings.paging === 1) pagingDiv = paging.pagingDiv;
            if (paging.showPagingSystem == true) {
                switch (style) {
                    case 'fromStart':
                        pagingDiv.find('a').hide();
                        for (i = 0; i <= options.pagingBy - 1; i++) {
                            pagingDiv.find('a[data-id="' + chapterIds[i] + '"]').show();
                        }
                        pagingDiv.find('a.next').show();
                        pagingDiv.find('a.prev').hide();
                        break;
                    case 'almostStart':
                        pagingDiv.find('a').hide();
                        for (i = 1; i <= options.pagingBy; i++) {
                            pagingDiv.find('a[data-id="' + chapterIds[i + 1] + '"]').show();
                        }
                        pagingDiv.find('a.next').show();
                        pagingDiv.find('a.prev').show();
                        break;
                    case 'between':
                        pagingDiv.find('a').hide();
                        var active = pagingDiv.find('a.active'),
                            offset = Math.floor(options.pagingBy / 2),
                            activeId = active.data('id');
                        if (offset % 2 != 0) offset = offset - 1;
                        active.show();
                        for (i = 1; i <= options.pagingBy; i++) {
                            pagingDiv
                                .find(
                                    'a[data-id="' +
                                        chapterIds[chapterIds.indexOf(activeId) + i - offset - 1] +
                                        '"]',
                                )
                                .show();
                        }
                        pagingDiv.find('a.next').show();
                        pagingDiv.find('a.prev').show();
                        break;
                    case 'almostEnd':
                        pagingDiv.find('a').hide();
                        for (
                            i = chapterIds.length - 1;
                            i > chapterIds.length - 1 - options.pagingBy;
                            i--
                        ) {
                            pagingDiv.find('a[data-id="' + chapterIds[i - 2] + '"]').show();
                        }

                        pagingDiv.find('a.prev').show();
                        pagingDiv.find('a.next').show();
                        break;
                    case 'toEnd':
                        pagingDiv.find('a').hide();
                        for (
                            i = chapterIds.length - 1;
                            i > chapterIds.length - 1 - options.pagingBy;
                            i--
                        ) {
                            pagingDiv.find('a[data-id="' + chapterIds[i] + '"]').show();
                        }
                        pagingDiv.find('a.next').hide();
                        pagingDiv.find('a.prev').show();
                        break;
                }
                centerPaging();
            }
        }
        function switchPaging(element) {
            (moveto = element.data('moveto')), (paging.inProgress = 1);
            paging.moveto = moveto;
            paging.lastVisibleAnchorIndexOfChapters = chapterIds.indexOf(
                paging.pagingDiv.find('a:visible:not(".threeDots"):last').data('id'),
            );
            paging.firstVisibleAnchorIndexOfChapters = chapterIds.indexOf(
                paging.pagingDiv.find('a:visible:not(".threeDots"):first').data('id'),
            );
            paging.pagingDiv.find('a').hide();
            switch (moveto) {
                case 'next':
                    for (i = 1; i <= options.pagingBy; i++) {
                        paging.pagingDiv
                            .find(
                                'a[data-id="' +
                                    chapterIds[paging.lastVisibleAnchorIndexOfChapters + i] +
                                    '"]',
                            )
                            .show();
                    }
                    if (
                        chapterIds.indexOf(paging.pagingDiv.find('a:visible:last').data('id')) <
                        chapterIds.length - 1
                    ) {
                        paging.pagingDiv.find('a.next').show();
                    }

                    paging.pagingDiv.find('a.prev').show();
                    break;
                case 'prev':
                    paging.pagingDiv.find('a').hide();
                    for (i = 1; i <= options.pagingBy; i++) {
                        paging.pagingDiv
                            .find(
                                'a[data-id="' +
                                    chapterIds[paging.firstVisibleAnchorIndexOfChapters - i] +
                                    '"]',
                            )
                            .show();
                    }
                    if (
                        chapterIds.indexOf(paging.pagingDiv.find('a:visible:first').data('id')) > 0
                    ) {
                        paging.pagingDiv.find('a.prev').show();
                    }

                    paging.pagingDiv.find('a.next').show();
                    break;
            }
            paging.firstVisibleAnchorIndexOfChapters = null;
            paging.lastVisibleAnchorIndexOfChapters = null;
        }
        //BPZ
        function showIntro() {
            $('articleContent > h1').removeAttr('style').css({
                color: 'black',
                'text-decoration': 'none',
                cursor: 'normal',
            });
            $('articleContent > h1').removeAttr('style').unbind('mouseover');
            var oldItem = $('ul.listed > li.active'),
                newItem = $('ul.listed > li:first-child');
            hideAndShowNext(oldItem, newItem);
        }
        function centerPaging() {
            var anchorsWidth, pagingDivWidth, buttonsWidth;
            $that
                .find('.pagingHolder:first-of-type a')
                .filter("[style='display: block']")
                .each(function () {
                    anchorsWidth += $(this).width();
                });
        }

        function scrollToArticleTop() {
            var offset = $that.find('#article').offset().top;
            $(window).scrollTop(offset - 10);
        }

        return this;
    };
})(jQuery);
